import { AlertBox } from '@/components/common/AlertBox'
import { CardLinkButton } from '@/components/common/Card'
import { LinkRoute } from '@/components/common/Link'
import { SectionLabel } from '@/components/common/SectionLabel'
import { usePage } from '@/components/providers/PageProvider'
import { useCardRoleLinks } from '@/hooks/useCardRoleLinks'
import { useCardsRec } from '@/hooks/useCardsRec'
import { useLinkInternal } from '@/hooks/useLinkInternal'

import styles from './FeaturedRecTopline.module.scss'

export const FeaturedRecTopline = () => {
  const { buildRelative } = useLinkInternal()
  const { page } = usePage()
  const route = page?.route
  const rec = page?.featured?.rec
  const { card } = useCardsRec({ rec })
  const links = useCardRoleLinks({ mode: 'featured', rec })
  const label = page?.metadata?.label

  if (!rec) return null

  const isSoloPartner = route?.section === 'commandersFeatured' && card?.isLegalPartner && !rec.partnerRef

  return (
    <div className={styles.container}>
      {isSoloPartner && (
        <AlertBox variant='info'>
          This is <strong>{rec.name}</strong> with <strong>no partner</strong>. You may select a partner on the{' '}
          <LinkRoute href={buildRelative({ section: 'partnersFeatured' })}>As Partner page</LinkRoute>.
        </AlertBox>
      )}
      <div className={styles.heading}>
        <SectionLabel label={label} />
        <ul className={styles.links}>
          {links.map((link, i) => (
            <li key={i}>
              <CardLinkButton link={link} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
